import React from 'react';
import { DatePicker, Checkbox, Select } from 'antd';
import { toast } from 'react-toastify';
import services from '../../services';
import { withRouter } from 'react-router-dom';
import FormleftNev from '../common/FormleftNev';
import EntityFilter from '../common/EntityFilter'
import queryString, { parse } from 'query-string'
import FormNavbar from '../common/wizard_navbar';
import Lang from '../../lang'
import { Input, TextArea } from '@progress/kendo-react-inputs';
import $ from "jquery";
import { string } from 'prop-types';
const moment = require('moment');

const { Option } = Select
const InputFieldsAll = {
    DetalhesPenhora: [
        {
            key: "entidade",
            type: "multiselect",
            display: "Entidade"
        },
       
        {
            key: "tipoReclamacaoSugestao",
            type: "multiselect",
            display: "Área Técnica"
        },
        {
            key: "referencia",
            type: "text",
            display: "Refência"
        },
        {
            key: "utilizador",
            type: "text",
            display: "Utilizador de contacto"
        },
        {
            key: "mensagem",
            type: "textArea",
            display: "Mensagem"
        },
        {
            key: "email",
            type: "text",
            display: "E-mail"
        },
    ]
}

let apiFilters = {
    Filters: null,
    SortBy: 'ID',
    Page: 1,
    PageSize: 100,
    Filters: null,
    IsSortTypeDESC: false,
    IsPagination: false,
    
};

class NewSugestaoReclamacaoFormDetails extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error:null,
            entidade: null,
            tipo: null,
            areaTecnica: null,
            referencia: null,
            mensagem: null,
            email: null,
            utilizador: null,
            
            EntidadesDrop: [],
            idEntidadeSelecionada : null,
            AreaTecnicaDrop: [],
            idAreaTecnicaSelecionada: null
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        let parsed = queryString.parse(window.location.search)
        if(parsed.id){
            this.getEntidadeById(parsed.id)
        }
        

        (async () => {
            var filter={}
            const EntidadesDrop = await services.apiCall.requestApi("Transversal/GetUsersSIVDP", filter, 'get')
            this.setState({ EntidadesDrop });
            var filter2={Tipo: "SR"}
            const AreaTecnicaDrop = await services.apiCall.requestApi("Transversal/GetTiposReclamacoesAndPedidosAjuda", filter2, 'get')
            this.setState({ AreaTecnicaDrop });
        })();
    }

    handleChangeMarcaLocalizacao = (e) => {
        this.setState({ TwoInput: e });
        if(e == 2){
            this.setState({ SelecaoReencaminhar: true });
        }else{
            this.setState({ SelecaoReencaminhar: false });
        }
    }


    searchEntidade = (e) => {
        let entidades = []
        if (e == ""){
          return;
        }
        
        (async () => {
            if(this.props.location.search != ""){
                const filtersPreenchido = {"Nome" : e };
                    entidades = await services.apiCall.requestApi(
                        "/Entidades/ViewEntidadesFiscalizacao",
                        filtersPreenchido,
                        "get"
                    );
            }
            var Validanumero = /^\d+$/.test(e)
            if(Validanumero == false){
                const filters = {
                    "Nome" : e 
                };
                entidades = await services.apiCall.requestApi(
                    "/Entidades/ViewEntidadesFiscalizacao",
                    filters,
                    "get"
                );
            }else{
                const filters = {
                    "NIF" : e,
                };
                entidades = await services.apiCall.requestApi(
                    "/Entidades/ViewEntidadesFiscalizacao",
                    filters,
                    "get"
                );
            }
            
    
            this.setState({ entidades })
        })()
    }



    handleChangeMarcaLocalizacao = (e) => {
        this.setState({ idAreaTecnicaSelecionada: e });
    }
    handleChangeReferencia = (e) => {
        this.setState({ referencia: e.value });
    }
    
    handleChangeTexto = (e) => {
        this.setState({ mensagem: e.value });
    }
    handleChangeEmail = (e) => {
        this.setState({ email: e.value });
    }
    handleChangeUtilizador = (e) => {
        this.setState({ utilizador: e.value });
    }
    handleChangeEntidade= (e) => {
        this.setState({ idEntidadeSelecionada: e });
        this.setState({ defaultValueEntidade: e });
        
    }
    
    createInputs(nevkey) {
        let inputs = InputFieldsAll[nevkey].map((row, i) => {
            switch (row.type) {
                case "multiselect":
                    if(row.key == "tipoReclamacaoSugestao"){
                        console.log(this.state.idAreaTecnicaSelecionada, "AREA TECNICA")
                        return (
                            <React.Fragment key={i}>
                                <label style={{marginLeft:"15px" , marginBottom:"0px" , marginTop:"15px"}}>Tipo</label>
                                    <Select
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder="Selecione"
                                        className="estatoSelect"
                                        mode="single"
                                        onChange={(e) => this.handleChangeMarcaLocalizacao(e)}
                                        defaultValue={this.state.idAreaTecnicaSelecionada}
                                        value={this.state.idAreaTecnicaSelecionada}
                                        style={{ width: "100%", marginLeft:"15px" , marginRight:"15px" }}
                                    >
                                        <Option disabled>Selecione</Option>
                                        {(this.state.AreaTecnicaDrop && !!this.state.AreaTecnicaDrop.length) && this.state.AreaTecnicaDrop.map((item, index) => (
                                            <Option key={index} value={item.idTipoPedidoAjuda}>{item.nome}</Option>
                                        ))}
                                    </Select>                               
                            </React.Fragment> 
                        );
                    }else{
                        return (
                            <React.Fragment key={i}>
                                <label style={{marginLeft:"15px" , marginBottom:"0px"}}>Entidade</label>
                                <Select
                                    showSearch
                                    onSearch={(e) => this.searchEntidade(e)}
                                    optionFilterProp="children"
                                    placeholder="Selecione a entidade"
                                    className="mov-Ent-Select DropEntidade PedidoAjudaDropEntidade"
                                    defaultValue={this.state.defaultValueEntidade}
                                    value={this.state.defaultValueEntidade}
                                    onChange={(e) => this.handleChangeEntidade(e)}
                                    id="EntidadeDrop"
                                    style={{ width: "100%"}}>
                                
                                    <Option disabled >Selecione a entidade destino</Option>
                                    {(this.state.entidades && !!this.state.entidades.length) && this.state.entidades.map((item, index) => (
                                        <Option key={index} value={item.codEntidade}>{item.nome + " - " + item.nif} </Option>
                                    ))}
                                </Select>                          
                            </React.Fragment> 
                        );
                    }
                    
                break;
                case "textArea":
                    return(
                        <div className="col-md-12">
                            <div className="input-box active-grey" style={{marginTop:"25px"}}>
                            <label style={{position: "absolute",zIndex: "1",top: "-12px",left: "16px",backgroundColor: "white"}} className='k-label'>{Lang.langCheck.langRequest(`${row.display}`)}</label>
                                <TextArea
                                    id={row.key}
                                    name={row.key}
                                    type={row.type}
                                    style={{ width: "100%" , height: "200px",padding: "0" , paddingTop:"11px" }}
                                    className="input-1 k-textbox textareaFrases"
                                    label={Lang.langCheck.langRequest(`${row.display}`)}
                                    row={50}
                                    cols={50}
                                    value={this.state ? this.state.mensagem : ""}
                                    onChange={(e) => this.handleChangeTexto(e)}
                                />
                                
                            </div>
                        </div>
                    )
                break;
                case "text":
                    if(row.key == "referencia"){
                        return (
                            <div className="col-md-12">
                                <div className="input-box active-grey" style={{marginBottom:0}}>
                                    <Input
                                        id={row.key}
                                        name={row.key}
                                        type={row.type}
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        label={Lang.langCheck.langRequest(`${row.display}`)}
                                        value={this.state ? this.state.referencia : ""}
                                        onChange={(e) => this.handleChangeReferencia(e)}
                                    />
                                </div>
                            </div>
                        )
                    }else if(row.key == "email"){
                        return (
                            <div className="col-md-12">
                                <div className="input-box active-grey" style={{marginBottom:0}}>
                                    <Input
                                        id={row.key}
                                        name={row.key}
                                        type={row.type}
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        label={Lang.langCheck.langRequest(`${row.display}`)}
                                        value={this.state ? this.state.email : ""}
                                        onChange={(e) => this.handleChangeEmail(e)}
                                    />
                                </div>
                            </div>
                        )
                    }else{
                        return (
                            <div className="col-md-12">
                                <div className="input-box active-grey" style={{marginBottom:0}}>
                                    <Input
                                        id={row.key}
                                        name={row.key}
                                        type={row.type}
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        label={Lang.langCheck.langRequest(`${row.display}`)}
                                        value={this.state ? this.state.utilizador : ""}
                                        onChange={(e) => this.handleChangeUtilizador(e)}
                                    />
                                </div>
                            </div>
                        )
                    }
                    
                    break;
                default:
                    
                        return (
                            <div className="col-md-12">
                                <div className="input-box active-grey" style={{marginBottom:0}}>
                                    <Input
                                        id={row.key}
                                        name={row.key}
                                        type={row.type}
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        label={Lang.langCheck.langRequest(`${row.display}`)}
                                        value={this.state ? this.state.cod : ""}
                                        onChange={(e) => this.handleChangeCod(e)}
                                    />
                                </div>
                            </div>
                        )
                    
            }
        });
        return inputs
    }

    handleSelect = (value) => {
        try {
            this.setState({
                codEstatuto: value
            })
        } catch (error) {
            this.setState({error})
        }
    }

    handleEntitySelect = (value) => {
        try {
            this.setState({
                codEntidade: +value
            })
        } catch (error) {
            this.setState({error})
        }
    }

    createInputFields = () => {
        try {
            let InputFieldsdivs = Object.keys(InputFieldsAll).map((nevkey) => {
                return (<div className="bg-white middle p20" id={nevkey}>
                    <div className="head" style={{marginBottom: "10px"}}>
                        <h2> {Lang.langCheck.langRequest(`${nevkey}`)}</h2>
                       
                    </div>
                    <div className="row">
                        {this.createInputs(nevkey)}
                    </div>
                </div>
                )
            });
    
            return InputFieldsdivs;
        } catch (error) {
            this.setState({error})
        }
    }

    getEntidadeById = async (id) => {
        try {
            let parsed = queryString.parse(window.location.search)
            var data = {idPedidoAjuda: parsed.id}

            let _user = await services.apiCall.requestApi(
                "Transversal/GetSugestoesReclamacoesDetail",
                data,
                "get"
            );
            if (_user) {
                    this.setState({
                        entidade: _user[0].entidade,
                        tipoReclamacaoSugestao: _user[0].tipoReclamacaoSugestao,
                        referencia: _user[0].referencia,
                        mensagem: _user[0].mensagem,
                        utilizador: _user[0].utilizador,
                        email: _user[0].email,
                        idEntidadeSelecionada : _user[0].idEntidade,
                        defaultValueEntidade:  _user[0].idEntidade,
                        idAreaTecnicaSelecionada: _user[0].idAreaTecnicaSelecionada,
                    }) 
                    this.searchEntidade(_user[0].entidade);
                    this.handleChangeEntidade(_user[0].idEntidade)
            }  
        } catch (error) {
            this.setState({error})
        }
    }

    handleSubmit = (e, backUrl) => {
        e.preventDefault();
        try {  
            let parsed = queryString.parse(window.location.search)
            if(parsed.id != undefined && parsed.id != null){
                var id = parsed.id;
                this.handleEditPedidoAjuda(id ,backUrl);
            }else{
                this.handleAddPedidoAjuda(backUrl);
            }
            
        } catch (error) {
            this.setState({error})
        }
    }
    
    handleEditPedidoAjuda = async (id,backUrl) => {
        try {
                var data = {
                    idSugestaoReclamacao : id,
                    criadoPor: window.localStorage.getItem('username'),
                    idEntidade : String(this.state.idEntidadeSelecionada),
                    isReclamacao:  this.state.idAreaTecnicaSelecionada == 1 ? false : true,
                    referencia : this.state.referencia,
                    PessoaContacto: this.state.utilizador,
                    mensagem: this.state.mensagem,
                    email: this.state.email
                }
                var res = await services.apiCall.requestApi(`/Transversal/EditSugestaoReclamacao`, data, 'post')
                if (res) {
                    if (backUrl) {
                        this.props.history.push({
                            pathname: backUrl,
                            state:{topBarMenu : this.props.topBarMenuOption}
                        })
                    }
                }
            
        } catch (error) {
            this.setState({error})
        }
    }


    handleAddPedidoAjuda = async (backUrl) => {
        try {
                var data = {
                    idAreaTecnica:  this.state.idAreaTecnicaSelecionada,
                    referencia: this.state.referencia,
                    mensagem: this.state.mensagem,
                    email: this.state.email,
                    idUtilizador: null,
                    idEntidade: String(this.state.idEntidadeSelecionada),
                    criadoPor: window.localStorage.getItem('username'),
                    pessoaContacto: this.state.utilizador
                }
                var res = await services.apiCall.requestApi(`/Transversal/SubmeterSugestaoReclamacao`, data, 'post')
                if (res) {
                    if (backUrl) {
                        this.props.history.push({
                            pathname: backUrl,
                            state:{topBarMenu : this.props.topBarMenuOption}
                        })
                    }
                }
            
        } catch (error) {
            this.setState({error})
        }
    }


    checkRequestData = () => {
        if(this.state.codEntidade == 0 || this.state.codEstatuto.length == 0){
            return false
        }else{
            return true
        }
    }

    handleCreateEntityEstatutoList = async (backUrl) => {
        try {
            let data = {
                codEntidade: this.state.codEntidade,
                codEstatuto: this.state.codEstatuto,
            }
            let res ;
            let {isChecked} = this.state;
            if(isChecked || !backUrl){
            res= await services.apiCall.requestApi('/BusEntidadeEstatuto/Create', data, 'post')
            }
            if (res) {
                this.setState({
                    isChecked: false,
                })
               
            }
            if (backUrl ) {
                this.props.history.push({
                    pathname: '/entity_rule_list',
                    state:{topBarMenu : this.props.topBarMenuOption}
                })
            }
        } catch (error) {
            this.setState({error})
        }

    }

    render() {
        console.log("state",this.state)
        console.log("props",this.props)
        if(this.state.error){
            throw this.state.error
        }
        return (
            <div className="dashboard">
                {
                    
                        <FormNavbar to={'/Reclamacoes_Sugestoes'} topBarMenu={this.props.topBarMenuOption} handleSubmit={(e, url) => this.handleSubmit(e, url)} type='auditing' headName="Pedido de ajuda" />
                }
                <div className="full-container edit-ward">
                    <FormleftNev InputFieldsAll={InputFieldsAll} />
                    <div className="right-section">

                        <div className="row top-serch">
                            {
                                this.createInputFields()
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default withRouter(NewSugestaoReclamacaoFormDetails);